import { render } from "./CoBrandPearl.vue?vue&type=template&id=155271a4&scoped=true"
import script from "./CoBrandPearl.vue?vue&type=script&lang=js"
export * from "./CoBrandPearl.vue?vue&type=script&lang=js"

import "./CoBrandPearl.vue?vue&type=style&index=0&id=155271a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155271a4"]])

export default __exports__